import { lazyLoad } from '@react-page/core'
import createPlugin from './createPlugin'

import FAQsRenderer from './Renderer/FAQsRenderer'

const FAQsForm = lazyLoad(() => import('./Form/FAQsForm'))

const faqsPlugin = settings =>
    createPlugin({
        Renderer: FAQsRenderer,
        Controls: FAQsForm,
        ...settings,
    })

const faqs = faqsPlugin()
export default faqs

export { faqsPlugin }
